import styled from '@emotion/styled';
import { useNavigate } from 'react-router-dom';
import Button from '~/components/Button';
import Gap from '~/components/Gap';
import Text from '~/components/Text';
import { BILLING_ROUTE } from '~/constants/routes';
import { useUserLimits } from '~/hooks/useUserLimits';
import ClientsIcon from '~/icons/ClientsIcon';
import { analytics, ANALYTICS_EVENTS } from '~/services/analyticsService';
import { useIsDesktop } from '~/hooks/useIsDesktop';

const IconWrapper = styled.div`
  min-width: 104px;
  min-height: 104px;
  max-width: 104px;
  max-height: 104px;
  border-radius: 8px;
  background-color: #f7f5ff;
`;

interface IEmptyClientListProps {
  handleAddClient(): void;
}

const EmptyClientList = ({ handleAddClient }: IEmptyClientListProps) => {
  const { canCreateClient } = useUserLimits();
  const isDesktop = useIsDesktop();
  const navigate = useNavigate();

  const handleCreateClick = () => {
    analytics.capture(ANALYTICS_EVENTS.BUTTON_CLICKED, {
      screen_name: 'Clients',
      button_name: 'Add Client',
      button_id: 'add_client',
      section: 'Empty View',
    });

    if (canCreateClient) {
      handleAddClient();
    } else {
      navigate(`${BILLING_ROUTE}?ref=clients`);
    }
  };

  return (
    <div className="v-center">
      <Gap t={60} />
      <IconWrapper className="center">
        <ClientsIcon size={42} fill="var(--t-black)" />
      </IconWrapper>
      <Gap t={32} />
      <Text size={isDesktop ? 'md' : 'smd'} className="bold">
        No client found
      </Text>
      <Gap t={24} />
      <Text style={{ textAlign: 'center' }}>Add your first client and start invoicing them right away.</Text>
      <Gap t={24} />
      <Button size="smd" onClick={handleCreateClick}>
        Add client
      </Button>
    </div>
  );
};

export default EmptyClientList;
